import * as React from 'react'
import { Outlet } from 'react-router-dom'

import type { Back, Tab } from 'modules/core/components/Card/types'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useMemo } from 'modules/core/hooks/useMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

import type { ShowRouteContextParams } from 'modules/automations/lib/ShowRouteContextParams'
import { automations } from 'modules/automations/store/collections/automations'
import { triggers } from 'modules/automations/store/collections/triggers'
import type { ITriggerWithConditions } from 'modules/automations/store/models/Trigger'

const AutomationsShowRootPage = () => {
  const { navigation } = useNavigation()
  const { id } = useStrictParams<'id'>()
  const [trigger, setTrigger] = React.useState<ITriggerWithConditions>()
  const automation = automations.get(Number(id))

  useEffect(() => {
    const fetchTrigger = async () => {
      if (!automation) {
        return
      }

      const item = await triggers.show(automation.attributes.trigger)

      setTrigger(item)
    }

    fetchTrigger()
  }, [])

  const back: Back = {
    href: navigation.settings.automations.fullPath(),
    label: i18n.t('automations.automations'),
  }

  const tabs = useMemo<Tab[]>(
    () => [
      {
        name: i18n.t('automations.show.details.tab'),
        index: true,
        href: navigation.settings.automations.id.details.fullPath({ id }),
      },
      {
        name: i18n.t('automations.show.history.tab'),
        index: true,
        href: navigation.settings.automations.id.history.fullPath({ id }),
      },
    ],
    [id]
  )

  const title = automation?.attributes.name ?? ''

  const values: ShowRouteContextParams = {
    back,
    automation,
    trigger,
    tabs,
    title,
  }

  return <Outlet context={values} />
}

export default AutomationsShowRootPage
